import React, { useState, useEffect } from "react";
import { Table, Input } from "antd";
import EditForm from "./EditForm";
import UpdateImage from "./UpdateImage";
import appConfig from "../../helpers/appConfig";
import DeleteProduct from "./DeleteProduct";
import Ingredents from "./Ingredents";
import { sendNotification } from "../../helpers/commFuc";
import BootstrapSwitchButton from "bootstrap-switch-button-react";
const ProductList = ({
  products,
  updateProduct,
  categoryId,
  updateProductImage,
  successData,
  getProducts,
  deleteProduct,
  stockProduct,
  saveIngredent,
  isShowWeb,
  isLoading,
  isShowWebValues,
  setIsShowWebValues,
}) => {
  let [editingKey, setEditingKey] = useState("");
  let [currentPage, setCurrentPage] = useState(1);
  let [visibleEditPopover, setVisibleEditPopover] = useState();
  let [name, setName] = useState("");
  let [price, setPrice] = useState("");
  let [itemNo, setItemNo] = useState("");
  let [showToggle, setShowToggle] = useState(isShowWebValues);
  useEffect(() => {
    if (
      successData &&
      Object.keys(successData).length !== 0 &&
      (successData.actionType === "updateProductImage" ||
        successData.actionType === "deleteProduct" ||
        "saveIngredent")
    ) {
      getProducts(categoryId);
    }
  }, [successData]);
  const edit = (key, record) => {
    setEditingKey(key);
    setName(record.name);
    setPrice(record.price);
    setItemNo(record.itemNo);
  };
  const save = (id) => {
    if (validateForm()) {
      setEditingKey("");
      const data = {
        price,
        name,
        itemNo,
        id,
        categoryId
      };
      updateProduct(data);
    }
  };

  const validateForm = () => {
    if (!name.trim() || !price || !itemNo) {
      sendNotification("error", "All fields are required!");
      return false;
    }
    return true;
  };
  const cancel = () => {
    setEditingKey("");
  };

  const onChangeIsWeb = (e, record, index) => {
    isShowWebValues[record._id] = e;
    isShowWeb(e,record);
    setIsShowWebValues(isShowWebValues);
  };
  const columns = [
    {
      title: "Produkt Nummer",
      dataIndex: "itemNo",
      width: "6%",
      editable: true,
      key: 1,
      render: (text, record, index) => {
        return editingKey === record.name ? (
          <Input
            type="number"
            value={itemNo}
            onChange={(e) => setItemNo(e.target.value)}
          />
        ) : (
          <> {text}</>
        );
      }
    },
    {
      title: "Produkt Navn",
      dataIndex: "name",
      width: "20%",
      editable: true,
      key: 2,
      render: (text, record, index) => {
        return editingKey === record.name ? (
          <Input value={name} onChange={(e) => setName(e.target.value)} />
        ) : (
          <> {text}</>
        );
      }
    },
    {
      title: "Produkt bilde",
      width: "15%",
      editable: false,
      key: 3,
      render: (text, record) => {
        return (
          <img
            src={`${appConfig.s3url}/${record.thumbnail}`}
            style={{ maxWidth: 120, maxHeight: 120, borderRadius: "100%" }}
          />
        );
      }
    },
    {
      title: "Produkt Pris",
      width: "10%",
      editable: true,
      dataIndex: "price",
      key: 4,
      render: (text, record, index) => {
        return editingKey === record.name ? (
          <Input
            type="number"
            value={price}
            onChange={(e) => setPrice(e.target.value)}
          />
        ) : (
          <> {text}</>
        );
      }
    },
    {
      title: "Tilgjengelighet",
      width: "10%",
      editable: true,
      // dataIndex: "price",
      key: 100,
      render: (text, record, index) => {
        return (
          <>
            <BootstrapSwitchButton
              size="xs"
              style="btn-ab"
              onstyle="btn-ab"
              checkedChildren="Yes"
              unCheckedChildren="No"
              checked={isShowWebValues[record._id]}
              onChange={(e) => {
                onChangeIsWeb(e,record, index);
              }}
            />
          </>
        );
      },
    },
    {
      title: "Handling",
      dataIndex: "operation",
      width: "20%",
      key: 5,
      render: (text, record) => {
        return (
          <>
            <Ingredents
              record={record}
              stockCats={stockProduct}
              saveIngredent={saveIngredent}
            />
            <EditForm
              record={record}
              edit={edit}
              isEditing={isEditing}
              save={save}
              cancel={cancel}
              visibleEditPopover={visibleEditPopover}
              setVisibleEditPopover={setVisibleEditPopover}
            />
            <UpdateImage
              record={record}
              updateProductImage={updateProductImage}
            />
            <DeleteProduct record={record} deleteProduct={deleteProduct} />
          </>
        );
      }
    }
  ];
  const isEditing = (record) => {
    return record.name === editingKey ? editingKey : undefined;
  };
  const productColumns = columns.map((col) => {
    if (!col.editable) {
      return col;
    }
    return {
      ...col,
      onCell: (record) => ({
        record,
        inputtype: col.dataIndex === "price" ? "number" : "text",
        title: col.title,
        editing: isEditing(record)
      })
    };
  });
  return (
    <div className="categoryListTable">
      <Table
        rowKey={(record) => record._id}
        loading={isLoading}
        onChange={(pagination) => setCurrentPage(pagination.current)}
        bordered
        dataSource={products}
        columns={productColumns}
        rowClassName="editable-row"
        className="tableClass"
      />
    </div>
  );
};
export default ProductList;
